import React, { useState } from "react";
import styles from "./Hero.module.css";
import { Search, Smartphone, Star, CheckCircle, ArrowLeft } from "lucide-react";

const Hero = () => {
  const [searchVal, setSearchVal] = useState("");

  const features = [
    {
      icon: <CheckCircle size={18} />,
      text: "مراجع علمية متخصصة للمعلمين والطلاب",
    },
    {
      icon: <CheckCircle size={18} />,
      text: "كتب دراسية لجميع المراحل التعليمية",
    },
    {
      icon: <CheckCircle size={18} />,
      text: "توصيل سريع لجميع أنحاء الجمهورية",
    },
    {
      icon: <CheckCircle size={18} />,
      text: "جودة عالية وضمان أصلي على المنتجات",
    },
    { icon: <CheckCircle size={18} />, text: "تسوق آمن مع وسائل دفع متعددة" },
    { icon: <CheckCircle size={18} />, text: "أفضل الأسعار والخصومات الحصرية" },
  ];

  const bookImages = [
    {
      src: "/images/book1.jpg",
      alt: "كتاب مدرسي 1",
      label: "اللغة الإنجليزية",
    },
    { src: "/images/book2.jpg", alt: "كتاب مدرسي 2", label: "اللغة الألمانية" },
    { src: "/images/book3.jpg", alt: "كتاب مدرسي 3", label: "الرياضيات" },
    { src: "/images/book4.jpg", alt: "كتاب مدرسي 4", label: "العلوم" },
  ];

  return (
    <section className={styles.hero}>
      <div className={styles.blob1} />
      <div className={styles.blob2} />
      <div className={styles.dots} />
      <div className={styles.decoLine} />

      <div className={styles.inner}>
        <div className={styles.contentSide}>
          <div className={styles.topBadge}>
            <span className={styles.dotPulse} />
            منصتك المفضلة للكتب والمراجع في مصر
          </div>

          <h1 className={styles.mainTitle}>
            كتبك المدرسية ومراجعك
            <br />
            كلها في <em className={styles.highlight}>شاشة موبايلك</em>
          </h1>

          <p className={styles.desc}>
            <strong className={styles.brand}>MyStore</strong> — تجربة تسوق
            استثنائية للمناهج التعليمية والمراجع الأكاديمية. بأعلى جودة، وأفضل
            سعر، وتوصيل لجميع أنحاء الجمهورية.
          </p>

          <div className={styles.searchBox}>
            <button className={styles.searchBtn}>ابحث الآن</button>
            <input
              type="text"
              value={searchVal}
              onChange={(e) => setSearchVal(e.target.value)}
              placeholder="ابحث عن كتابك أو مرحلتك الدراسية..."
              className={styles.searchInput}
            />
            <span className={styles.searchIcon}>
              <Search size={18} />
            </span>{" "}
          </div>

          <div className={styles.features}>
            {features.map((f, i) => (
              <div
                className={styles.featItem}
                key={i}
                style={{ animationDelay: `${0.1 + i * 0.05}s` }}
              >
                <div className={styles.featIcon}>{f.icon}</div>
                <span>{f.text}</span>
              </div>
            ))}
          </div>

          <div className={styles.ctaRow}>
            <button className={styles.btnPrimary}>
              تسوق الآن
              <ArrowLeft size={18} />
            </button>{" "}
            <button className={styles.btnGhost}>
              <Smartphone size={18} />
              حمّل التطبيق
            </button>{" "}
          </div>

          <p className={styles.trustLine}>
            +50,000 طالب ومعلم يثقون في MyStore
            <Star size={16} fill="currentColor" />
            تقييم 4.9
          </p>
        </div>

        <div className={styles.visualSide}>
          <div className={styles.phoneWrap}>
            <div className={styles.phone}>
              <div className={styles.screen}>
                <div className={styles.phHeader}>
                  <div className={styles.phBadge}>مرحباً بكِ .. Yasmine</div>
                  <div className={styles.phAvatar} />
                </div>

                <div className={styles.ticker}>
                  <span>
                    تخصصية للمدرسين والطلاب &nbsp;•&nbsp; تسوق آمن مع وسائل دفع
                    متعددة &nbsp;•&nbsp; توصيل سريع لجميع أنحاء مصر
                    &nbsp;•&nbsp;
                  </span>
                </div>

                <div className={styles.phSearch}>
                  <Search size={12} /> ابحث عن كتابك المفضل...
                </div>

                <div className={styles.phLogoArea}>
                  <div className={styles.logoText}>
                    <span className={styles.logoOrange}>My</span>store
                  </div>

                  <div className={styles.booksGrid}>
                    {bookImages.map((book, i) => (
                      <div className={styles.bookCard} key={i}>
                        <img
                          src={book.src}
                          alt={book.alt}
                          className={styles.bookImg}
                          onError={(e) => {
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                        <div
                          className={styles.bookFallback}
                          style={{ display: "none" }}
                        ></div>
                        <span className={styles.bookLabel}>{book.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.fBadge}>خصم 30% اليوم</div>
          <div className={styles.fStars}>
            <Star size={16} fill="currentColor" />
            4.9 — +12,000 تقييم
          </div>{" "}
        </div>
      </div>
    </section>
  );
};

export default Hero;
